export const REM = (() => {
    var change = 'orientationchange' in window ? 'orientationchange' : 'resize';
    function calculate() {
      var deviceWidth = document.documentElement.clientWidth;
      if (deviceWidth < 1200) {
        deviceWidth = 1200;
      }
      document.documentElement.style.fontSize = deviceWidth / 19.2 + 'px';
    };
    window.addEventListener(change, calculate, false);
    calculate();
})()



// WEBPACK FOOTER //
// ./src/libs/rem.js